import { useEffect, useRef } from "react";
import clsx from "clsx";

interface NotificationViewChipProps {
  backgroundColor?: string;
  children: string;
}

function NotificationViewChip({
  backgroundColor,
  children,
}: NotificationViewChipProps) {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.style.backgroundColor =
        backgroundColor || "rgba(119,119,119,1)";
    }
  }, [backgroundColor]);

  return (
    <span ref={ref} className={clsx("notification-view-content__chip")}>
      {children}
    </span>
  );
}

export { NotificationViewChip };
